export enum QueryParameters {
  TPCI = 'tpci',
}
